import { HttpClient } from '../HttpClient';
/**
 * * Delete Project Log
 */
export const DeleteProjectLog = async (projectLogId) => {
  try {
    const { data } = await HttpClient.delete(`api/projectLogs/${projectLogId}`);
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
